module.exports = __webpack_public_path__ + "static/architecture-70fc306335c6224826d56dc862821ecd.svg";